import { render, staticRenderFns } from "./FormImport.vue?vue&type=template&id=226a52fb"
import script from "./FormImport.vue?vue&type=script&lang=ts"
export * from "./FormImport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports